import React from 'react';
import ContainerTemplate from '../../widgets/template/Container';
import EventosView from './EventosView';
import * as ROUTES from '../../router/Routes';

const EventosModule = () => {
  return (
    <ContainerTemplate active={ROUTES.eventos} routes={[]}>
      <EventosView />
    </ContainerTemplate>
  );
};

export default EventosModule;
